import React, { forwardRef } from "react";

type ClampLinesProps = {
  lines: number;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const ClampLines = forwardRef<HTMLDivElement, ClampLinesProps>(
  ({ lines, children, className = "", style = {} }, ref) => {
    const clampStyle: React.CSSProperties =
      lines > 0
        ? {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: lines,
          }
        : {};

    return (
      <div
        ref={ref}
        className={`${lines > 0 ? "overflow-hidden" : ""} ${className}`}
        style={{
          ...clampStyle,
          ...style,
        }}
      >
        {children}
      </div>
    );
  }
);

ClampLines.displayName = "ClampLines";

export default ClampLines;
